import React from 'react';
import Container from './Container';
import useScrollAnimation from '../hooks/useScrollAnimation';

const AboutTeamShowcase = () => {
  const headerRef = useScrollAnimation('scroll-animate-blur');
  const team1Ref = useScrollAnimation('scroll-animate-stagger');
  const team2Ref = useScrollAnimation('scroll-animate-stagger');
  const team3Ref = useScrollAnimation('scroll-animate-stagger');
  const team4Ref = useScrollAnimation('scroll-animate-stagger');

  return (
    <section id="our-team" className="about-team-showcase section">
      <Container>
        <div ref={headerRef} className="team-showcase-header scroll-animate-blur">
          <div className="container section-badge flex justify-center items-center gap-3 text-[16px] md:text-[20px]">
            <div className="badge-dot"></div>
            Our Team
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl">People You Can Rely On.</h2>
        </div>
        <div className="team-members-grid">
          <div ref={team1Ref} className="team-member-card scroll-animate-stagger hover-lift">
            <div className="member-photo hover-scale">
              <img src="/images/recognized_person.webp" alt="Amit Dhatombe" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Amit Dhatombe</h3>
            <p className="text-sm md:text-base lg:text-lg">Founder & Managing Director</p>
          </div>
          <div ref={team2Ref} className="team-member-card scroll-animate-stagger hover-lift">
            <div className="member-photo hover-scale">
              <img src="/images/recognized_person.webp" alt="Mamta Dongre" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Mamta Dongre</h3>
            <p className="text-sm md:text-base lg:text-lg">Executive Director</p>
          </div>
          <div ref={team3Ref} className="team-member-card scroll-animate-stagger hover-lift">
            <div className="member-photo hover-scale">
              <img src="/images/recognized_person.webp" alt="Chetan Dongre" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Chetan Dongre</h3>
            <p className="text-sm md:text-base lg:text-lg">Director - Domestic Airport Operations</p>
          </div>
          <div ref={team4Ref} className="team-member-card scroll-animate-stagger hover-lift">
            <div className="member-photo hover-scale">
              <img src="/images/recognized_person.webp" alt="Omkar Mahatukade" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Omkar Mahatukade</h3>
            <p className="text-sm md:text-base lg:text-lg">Head of Operations - Domestic</p>
          </div>
          {/* <div ref={team5Ref} className="team-member-card scroll-animate-stagger hover-lift">
            <div className="member-photo hover-scale">
              <img src="/images/recognized_person.webp" alt="Sanjay Morbale" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Sanjay Morbale</h3>
            <p className="text-sm md:text-base lg:text-lg">Operations Lead - Domestic</p>
          </div>
          <div ref={team6Ref} className="team-member-card scroll-animate-stagger hover-lift">
            <div className="member-photo hover-scale">
              <img src="/images/recognized_person.webp" alt="Sahil Patil" />
            </div>
            <h3>Sahil Patil</h3>
            <p>Head of Warehouse Operations</p>
          </div> */}
        </div>
      </Container>
    </section>
  );
};

export default AboutTeamShowcase;
